import React, { useEffect } from 'react';
import './Logout.scss';
import { useDispatch } from 'react-redux';
import { closeMainMenu, logout } from '../../actions';
import { useNavigate } from 'react-router-dom';

export default function Logout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(logout());
    dispatch(closeMainMenu());
    navigate('/signin', { replace: true });
  }, [dispatch, navigate]);

  return (
    <section className="Logout">
      <h1>Logged Out.</h1>
    </section>
  );
}
